import { render } from "./EvacuatorMovingTable.vue?vue&type=template&id=4f4e0865"
import script from "./EvacuatorMovingTable.vue?vue&type=script&lang=js"
export * from "./EvacuatorMovingTable.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__